(() => {
  const drawerSelector = '#moonbundle-cart-drawer';
  const progressSelector = '.levya-shipping-progress';
  let drawer;
  let panel;
  let animation;
  let wasOpen = false;
  let queued = false;

  function reset() {
    if (animation) animation.cancel();
    animation = null;
    if (!panel) return;
    panel.classList.remove('is-complete');
    panel.querySelector('[data-shipping-message]').textContent = 'Votre livraison est offerte';
  }

  function play() {
    reset();
    const currentPanel = panel;
    const fill = panel.querySelector('.levya-shipping-progress-fill');
    const complete = () => {
      if (panel !== currentPanel || !drawer.classList.contains('open')) return;
      panel.classList.add('is-complete');
      panel.querySelector('[data-shipping-message]').textContent = 'Livraison offerte débloquée !';
    };
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      complete();
      return;
    }
    animation = fill.animate(
      [{ transform: 'scaleX(0)' }, { transform: 'scaleX(1)' }],
      { duration: 1000, easing: 'ease-out', fill: 'forwards' }
    );
    animation.finished.then(complete).catch(() => {});
  }

  function update() {
    queued = false;
    drawer.querySelectorAll('.levya-cart-pack-image').forEach(image => {
      if (image.getAttribute('src') === 'https://cdn.shopify.com/s/files/1/0946/5869/1408/files/levya-escalier-gros-plan_fcdb984d-0d6d-42c2-9e33-e64a148ac104.png?v=1793197728') return;
      image.removeAttribute('srcset');
      image.src = 'https://cdn.shopify.com/s/files/1/0946/5869/1408/files/levya-escalier-gros-plan_fcdb984d-0d6d-42c2-9e33-e64a148ac104.png?v=1793197728';
    });
    const timer = drawer.querySelector('.moonbundle-cart-timer');
    if (!timer) return;
    const mountedPanel = drawer.querySelector(progressSelector);
    const replaced = !panel || !panel.isConnected || panel !== mountedPanel;
    if (replaced) {
      reset();
      panel = mountedPanel || document.createElement('section');
      panel.className = 'levya-shipping-progress';
      panel.setAttribute('aria-label', 'Livraison offerte');
      panel.innerHTML = '<p class="levya-shipping-progress-message" data-shipping-message role="status">Votre livraison est offerte</p><div class="levya-shipping-progress-rail" aria-hidden="true"><span class="levya-shipping-progress-fill"></span><span class="levya-shipping-progress-goal"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h11v11H3zM14 10h4l3 4v3h-7"/><circle cx="7" cy="18" r="2"/><circle cx="18" cy="18" r="2"/></svg></span></div>';
    }
    if (timer.nextElementSibling !== panel) timer.after(panel);
    const open = drawer.classList.contains('open');
    if (open && (!wasOpen || replaced)) play();
    if (!open && wasOpen) reset();
    wasOpen = open;
  }

  function schedule() {
    if (queued) return;
    queued = true;
    queueMicrotask(update);
  }

  function attach() {
    const found = document.querySelector(drawerSelector);
    if (!found || found === drawer) return;
    drawer = found;
    wasOpen = false;
    new MutationObserver(schedule).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    new MutationObserver(records => {
      if (records.some(record => !record.target.closest?.(progressSelector))) schedule();
    }).observe(drawer, { childList: true, subtree: true });
    update();
  }

  attach();
  if (!drawer) {
    const observer = new MutationObserver(() => {
      attach();
      if (drawer) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();
